import React, { useState, useEffect, useMemo, useRef } from "react";

import { createPortal } from "react-dom";

import { Box, Button, Typography } from "@mui/material";

import Backdrop from "@mui/material/Backdrop";

import CircularProgress from "@mui/material/CircularProgress";

import useMediaQuery from "@mui/material/useMediaQuery";

import BellSound from "../assets/bell_ring.mp3";

import { getUser } from "../../Model/LocalStorage";

import { postPlaceBid } from "../../Model/Auction";

import { getToken } from "../../Model/User";

import { getProfile, JoinAuction } from "../../../Model/User";

import { useNavigate } from "react-router-dom";



import BidHistory from "./components/BidHistory";

import SlideToBidControl from "./components/SlideToBidControl";

import { AccessButton, AccessNotice, PriceStat } from "./components/BidControls";

import { AnnouncementPanel } from "./components/RoomSections";

import { StatusNotice } from "./components/Status";

import { FONT, R, labelSx } from "./components/roomTheme";



/*

 * Lot information, bid history and (phones / tablets) the fixed slide-to-bid bar.

 * On desktop this renders the centre "lot information" column; its status, current bid and

 * "your bid" state are shown in the right-hand bidding panel through a React portal

 * (`currentSlot`), above the Place Bid control that midLayout renders there.

 *

 * BIDDING LOGIC IS UNCHANGED — incrementCount (postPlaceBid + socket "send_status" /

 * "send_Bid_amount", refresh on failure), the "receive_bid_amount" bell, handleClickOpen

 * (join auction), the details effect (incl. the "receiveMessage" announcement listener),

 * the "receiveFloorValue" listener, the slide-to-bid mechanics (stopSlide / handleMove and

 * the rules for when the knob can be dragged) and the pending / pause backdrop rule are

 * the original code.

 * SlideToBid import and unused imports / state.

 */




const date = new Date();



function RightLayout({

  details,

  mediadQuery,

  socket,

  room,

  setToggleValue,

  guest,

  status,

  currentSlot,

  isSocketConnected = true,

}) {
  const livestream = details?.livestream?.[0];

const videoUrl = livestream?.base_url || "";

const videoVisible =
  livestream?.is_visible === true ||
  livestream?.is_visible === 1 ||
  livestream?.is_visible === "1";
  const token = getToken();

  const soundRef = useRef();

  const [loading] = React.useState(false);

  const [, setData] = useState([]);

  const phoneMatch = useMediaQuery("(max-width:1200px)");

  const [userId, setUserId] = useState("");

  const navigate = useNavigate();



  const [highestBid, setHighestBid] = useState(0);

  const [, setBidAccount] = useState("");

  const [announcement, setAnnouncement] = useState("");

  const [dataAuction, setDataAuction] = useState([]);

  const [hammerPrice, setHammerPrice] = useState("");

  const [, setUsername] = useState("");

  const [group, setGroup] = React.useState("");

  const [lotNumber, setlotNumber] = useState("");

  const [getData, setGetData] = useState([]);

  const [startPrice, setStartPrice] = useState("");

  const [bidhistory, setBidHistory] = useState([]);

  const [highestNumber, setHighest] = useState("");

  const [, setGetBP] = useState("");

  const [setID, setIDset] = useState("");

  const [auctionID, setAuctionID] = useState("");

  const [, setPause] = React.useState(false);

  const [withdrawn, setWithdrawn] = React.useState(0);

  const [message] = useState("");



  const isPostingRef = useRef(false); // prevents double submissions

  const [bidError, setBidError] = useState("");

  const [nextBidamount, setNextBidamount] = useState("");

  const incrementCount = async (auctionID, setID, lotNumber, highestBid) => {

    if (isPostingRef.current) return; // Iwas double click

    isPostingRef.current = true;

    try {

      const florrData = { 

        auction_id: auctionID, 

        setId: setID, 

        lot_number: lotNumber, 

        amount: highestBid 

      };

      const results = await postPlaceBid(florrData);

      if (results.success) {

        setBidError("");

        const messageData = { room, status: 3, amount: highestBid, increment: highestBid };

        if (status === "FAIR_WARNING") {

          socket.emit("send_status", { message: "OPEN" });

        }

        // Keep the current auction state; realtime socket updates will sync the room.

        socket.emit("send_Bid_amount", { messageData, florrData });

      } else {

        console.error("Bid Failed:", results.msg);

        setBidError(results?.msg || "Invalid bid amount. Please try again.");

      }

    } catch (err) {

      console.error("Error in incrementCount:", err);

      setBidError("Unable to place the bid. Please try again.");

    } finally {

      isPostingRef.current = false;

    }

  };





  useEffect(() => {

  const handleBidAmount = (data) => {

    // Only play sound for actual new bid, not statuses 1 or 2

    if (data.status !== 1 && data.status !== 2) {

      document.getElementById("sound")?.click();

    }

    // Optionally sync latest data only for certain statuses

    if (["NEXTSLOT", "PASS", "WIN"].includes(data.status)) {

    }

  };



  // Get user info once

  const initUser = async () => {

    try {

      const user = await getUser();

      if (user) {

        setGroup(user.group);

        setUserId(user.id);

        setUsername(user.email);

      }

    } catch (err) {

      console.error("Failed to get user:", err);

    }

  };



  initUser();



  socket.on("receive_bid_amount", handleBidAmount);



  return () => {

    socket.off("receive_bid_amount", handleBidAmount);

  };

}, [socket, group]); // can remove `group` if ListData can use latest ref instead





  const handleClickOpen = async () => {

    const profileData = await getProfile();

    const profile = profileData.data[0];



    if (profile.paymongo_payment_method_id) {

      // ✅ Already has a payment method, proceed to join

      const joinResult = await JoinAuction(auctionID);



      if (joinResult.success === false) {

        alert(`Join auction failed: ${joinResult.msg}`);

      } else {

        alert(joinResult.msg);

        window.location.reload(); // refresh the page

      }

    } else {

      navigate("/signup", {

        state: {

          userInfo: profile,

        },

      });

    }

  };





  function SoundTrip() {

    var resp = new Audio(BellSound).play();



    if (soundRef !== undefined) {

      resp

        .then((_) => {

          resp.autoplay = true;

          resp.current.focus();

        })

        .catch((error) => {

          //show error

          //  console.log("error")

        });

    }

  }





  useEffect(() => {

    // Initialize sound once

    if (!soundRef.current) {

      soundRef.current = new Audio(BellSound);

    }

    if (!details) return; // skip if no details

    const lot = details.lot?.details?.[0] || {};

    const auction = details.auction_details || {};

    // Only update state if values have changed to prevent unnecessary re-renders

    setGetData(details.lot.details || []);

    setBidError("");

    setGetBP(lot.bp || "");

    setData(auction);

    setBidHistory(details.bid_history || []);

    setBidAccount(details.bidCount || 0);

    setIDset(auction.id || "");

    setAuctionID(auction.auction_id || "");

    setPause(lot.lot_status === "PAUSE");

    setDataAuction(details);

    setlotNumber(lot.lot_number || "");

    setStartPrice(lot.starting_price || 0);

    setWithdrawn(lot.isWithdrawn);

    setHighestBid(lot.hp === 0 || lot.hp === null ? lot.starting_price : details.increment);

    setNextBidamount(lot.hp === 0 ? lot.starting_price : details.increment);

    setHammerPrice(lot.hp || 0);

    setHighest(Math.max(...(details.bid_history || []).map((o) => o.hammer || 0)));

    setAnnouncement(details.announcement?.[0]?.announcement || "");

    // Socket listener

    const handleAnnouncement = (data) => setAnnouncement(data.message);

    socket.on("receiveMessage", handleAnnouncement);

    return () => {

      socket.off("receiveMessage", handleAnnouncement);

    };

  }, [details, socket]);



  useEffect(() => {

    const handleFloorUpdate = (data) => {

      //  console.log("📩 Received floor value update:", data);

      setHighestBid(data.floorValue);

    };



    socket.on("receiveFloorValue", handleFloorUpdate);



    return () => {

      socket.off("receiveFloorValue", handleFloorUpdate);

    };

  }, [socket]);





  const [isSliding, setIsSliding] = useState(false);

  const sliderRef = useRef(null);

  const containerRef = useRef(null);

  const startSlide = () => setIsSliding(true);



// Mouse handlers

const handleMouseDown = () => startSlide();

const handleMouseMove = (e) => handleMove(e.clientX);

const handleMouseUp = () => stopSlide();



// Touch handlers

const handleTouchMove = (e) => handleMove(e.touches[0].clientX);

const handleTouchEnd = () => stopSlide();



const stopSlide = () => {

  if (!isSliding) return;

  setIsSliding(false);



  const slider = sliderRef.current;

  const container = containerRef.current;



  const hasWonBid = bidhistory.some(

    (val) =>

      val.userId === userId &&

      val.win_status === "WIN" &&

      val.hammer === highestNumber

  );



  const isPendingOrSold =

    status === "PENDING" ||

    status === "PAUSE" ||

    status === "SOLD" ||

    status === "PASS";

  const isAdmin = group === "ADMIN";



  // ✅ Trigger when slider passes 60% of container width

  const slideThreshold = container.offsetWidth * 0.6;

  const sliderCenter = slider.offsetLeft + slider.offsetWidth / 2;



  const isBeyondThreshold = sliderCenter >= slideThreshold;



  if (isBeyondThreshold) {

    // Trigger the action

    incrementCount?.(auctionID, setID, lotNumber, highestBid);



    // ✅ Always reset if admin

    const shouldResetSlider = isAdmin || !hasWonBid || isPendingOrSold;



    if (shouldResetSlider) {

      slider.style.left = "0px";

    }

  } else {

    // Reset slider if not beyond threshold

    slider.style.left = "0px";

  }

};



const highestNumberBidder = useMemo(() => {

  if (!bidhistory.length) return "0";

  return Math.max(...bidhistory.map(b => b.hammer)).toLocaleString();

}, [bidhistory]);





const isWinningBid = bidhistory.some(

  (val) =>

    val.userId === userId &&

    val.win_status === "WIN" &&

    val.hammer === highestNumber

);



  const handleMove = (clientX) => {

    if (!isSliding) return;



    const container = containerRef.current;

    const slider = sliderRef.current;

    const containerRect = container.getBoundingClientRect();

    let newLeft = clientX - containerRect.left - slider.offsetWidth / 2;



    newLeft = Math.max(

      0,

      Math.min(newLeft, container.offsetWidth - slider.offsetWidth)

    );

    slider.style.left = `${newLeft}px`;

  };



  // Kunin ang priority status: Socket Status muna, fallback sa API Details

const activeStatus = (status && status !== "") 

? status 

: details?.lot?.details?.[0]?.lot_status;



// I-check ang specific conditions para sa Backdrop

const isPending = activeStatus === "PENDING";

const isPause = activeStatus === "PAUSE";

const isLive = ["OPEN", "FAIR_WARNING"].includes(activeStatus);





  const gotoLogin = () => {

    window.location.href = `/login`;

  };



  // Same rule as before for when the slide knob can be dragged.

  const wonBidCount = bidhistory.filter(

    (val) =>

      val.userId === userId &&

      val.win_status === "WIN" &&

      val.hammer === highestNumber

  ).length;

  const knobDownHandler =

    wonBidCount ||

    status === "PENDING" ||

    status === "PAUSE" ||

    status === "SOLD" ||

    status === "UNSOLD"

      ? group === "ADMIN"

        ? withdrawn === 1

          ? undefined

          : handleMouseDown

        : undefined

      : withdrawn === 1

      ? undefined

      : handleMouseDown;



  const slideToBid = (

    <SlideToBidControl

      containerRef={containerRef}

      sliderRef={sliderRef}

      containerHandlers={{

        onMouseMove: handleMouseMove,

        onMouseUp: handleMouseUp,

        onMouseLeave: handleMouseUp,

        onTouchMove: handleTouchMove,

        onTouchEnd: handleTouchEnd,

      }}

      onKnobMouseDown={knobDownHandler}

      onKnobTouchStart={knobDownHandler}

      winning={isWinningBid}

      isAdmin={group === "ADMIN"}

      highestBidText={"₱ " + highestNumberBidder}

      nextBidamount={"₱ " + nextBidamount.toLocaleString()}

    />

  );



  // Phones / tablets: what goes in the fixed bottom bar (same order of rules as before).

  // Pending / declined notices are shown inline instead.

  const mobileNotice =

    token === null

      ? null

      : guest === "pending" || guest === "Not approved"

      ? "pending"

      : guest === "declined"

      ? "declined"

      : null;

  const mobileBarContent =

    token === null ? (

      <AccessButton onClick={gotoLogin}>Login to bid</AccessButton>

    ) : mobileNotice ? null : group === "ADMIN" ? (

      slideToBid

    ) : guest === 0 ? (

      <AccessButton onClick={handleClickOpen}>Join room request</AccessButton>

    ) : (

      slideToBid

    );



  // Your bidding state — same rule as the bid history rows (winning = your WIN bid at the

  // highest hammer). Shown only when you have bid on this lot.

  const hasMyBid = bidhistory.some((val) => val.userId === userId);

  const myBidState = hasMyBid ? (

    <Box

      role="status"

      sx={{

        mt: 1,

        px: 1.25,

        py: 0.75,

        fontFamily: FONT,

        fontSize: "0.8125rem",

        fontWeight: 700,

        color: isWinningBid ? R.success : R.danger,

        bgcolor: isWinningBid ? R.successBg : R.dangerBg,

        borderLeft: `3px solid ${isWinningBid ? R.success : R.danger}`,

      }}

    >

      {isWinningBid ? "You are the highest bidder" : "You have been outbid"}

    </Box>

  ) : null;



  const hasCurrent = hammerPrice !== 0;

  const currentBid = (

    <PriceStat

      size="current"

      label="Current bid"

      value={hasCurrent ? "₱ " + hammerPrice.toLocaleString() : "No bids yet"}

    />

  );



  const startingPrice = (

    <PriceStat

      size="current"

      label="Starting bid"

      value={startPrice ? "₱ " + startPrice.toLocaleString() : "0"}

    />

  );
  return (

    <Box sx={{ fontFamily: FONT, height: mediadQuery === false ? "auto" : "100%", minHeight: 0 }}>

      {mediadQuery === false ? (

        /* ================= MOBILE ================= */

        <Box

          sx={{

            width: "100%",

            minHeight: 0,

            px: { xs: 1.5, sm: 0 },

            pt: 0,

          }}

        >

          {/* The lot summary / Watch Video / View Lots controls live in MidLayout.

              Keep this area focused on announcements and the fixed bidding controls. */}

          {myBidState}



          {mobileNotice && (

            <Box sx={{ mt: 1.25 }}>

              <AccessNotice kind={mobileNotice} />

            </Box>

          )}



          

          {/* Keep bid history visible on phones/tablets, directly below announcements. */}
          <Box
            sx={{
              mt: 1.5,
              width: "100%",
              minWidth: 0,
              overflow: "hidden",
              border: `1px solid ${R.line}`,
              bgcolor: R.paper,
              p: 1.25,
            }}
          >
            <BidHistory
              bidhistory={bidhistory}
              userId={userId}
              highestNumber={highestNumber}
              status={status}
              group={group}
              limit={7}
              fill
              compact
            />
          </Box>
<Box sx={{ mt: 1 }}>

            <AnnouncementPanel text={announcement} />

          </Box>
          <Typography

            sx={{

              ...labelSx,

              fontWeight: 400,

              textAlign: "center",

              py: 2,

            }}

          >

            © {date.getFullYear()} Leon Gallery Auctions

          </Typography>



          {mobileBarContent && (

            <Box

              aria-hidden="true"

              sx={{

                height: bidError

                  ? "calc(138px + env(safe-area-inset-bottom))"

                  : "calc(92px + env(safe-area-inset-bottom))",

              }}

            />

          )}



          {mobileBarContent && (

            <Box

              sx={{

                position: "fixed",

                left: 0,

                right: 0,

                bottom: 0,

                zIndex: 1000,

                bgcolor: R.paper,

                borderTop: `1px solid ${R.lineStrong}`,

                boxShadow: "0 -4px 16px rgba(0,0,0,0.08)",

                px: { xs: 1, sm: 1.25 },

                pt: 0.75,

                pb: "calc(7px + env(safe-area-inset-bottom))",

              }}

            >

              <Box sx={{ maxWidth: 1000, mx: "auto" }}>

                <Box

                  sx={{

                    display: "grid",

                    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",

                    alignItems: "center",

                    gap: 1,

                    mb: 0.6,

                    px: 0.25,

                  }}

                >

                  <Box>

                    <Typography

                      sx={{

                        ...labelSx,

                        fontSize: "0.6rem",

                        fontWeight: 600,

                      }}

                    >

                      Starting Price

                    </Typography>



                    <Typography

                      sx={{

                        fontFamily: FONT,

                        fontSize: { xs: "0.84rem", sm: "0.95rem" },

                        lineHeight: 1.1,

                        fontWeight: 700,

                        color: R.ink,

                      }}

                    >

                      ₱ {startPrice.toLocaleString()}

                    </Typography>

                  </Box>



                  <Box sx={{ textAlign: "right" }}>

                    <Typography

                      sx={{

                        ...labelSx,

                        fontSize: "0.6rem",

                        fontWeight: 600,

                      }}

                    >

                      Current Bid

                    </Typography>



                    <Typography

                      sx={{

                        fontFamily: FONT,

                        fontSize: { xs: "0.84rem", sm: "0.95rem" },

                        lineHeight: 1.1,

                        fontWeight: 700,

                        color: R.ink,

                      }}

                    >

                      {hasCurrent

                        ? "₱ " + hammerPrice.toLocaleString()

                        : "No bids yet"}

                    </Typography>

                  </Box>

                </Box>



                {bidError && (

                  <Box

                    role="alert"

                    sx={{

                      mb: 0.75,

                      px: 1.25,

                      py: 0.75,

                      borderLeft: `3px solid ${R.danger}`,

                      bgcolor: R.dangerBg,

                      color: R.danger,

                      fontFamily: FONT,

                      fontSize: "0.75rem",

                      lineHeight: 1.35,

                    }}

                  >

                    {bidError}

                  </Box>

                )}



                {mobileBarContent}

              </Box>

            </Box>

          )}

        </Box>

      ) : (

        /* ================= DESKTOP: LIVE VIDEO + BID HISTORY ================= */

        <Box
          sx={{
            height: "100%",
            minHeight: 0,
            display: "grid",
            gridTemplateRows: "minmax(0, auto) minmax(0, 1fr)",
            overflow: "hidden",
          }}
        >
          {/* Center the live player within the available column. */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              maxHeight: 340,
              minHeight: 0,
              mx: "auto",
              p: 1.25,
              boxSizing: "border-box",
              borderBottom: `1px solid ${R.line}`,
              bgcolor: R.dark,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                maxWidth: 760,
                aspectRatio: "16 / 9",
                maxHeight: 310,
                mx: "auto",
                bgcolor: "#000",
                overflow: "hidden",
              }}
            >
              <Box
                component="iframe"
                title="Live auction video"
                src={videoUrl}
                frameBorder="0"
                allowFullScreen
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  display: "block",
                }}
              />
            </Box>
          </Box>

          <Box sx={{ minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden", p: 1.5 }}>

            <BidHistory bidhistory={bidhistory} userId={userId} highestNumber={highestNumber} status={status} group={group} limit={7} fill compact />
           
              <Box sx={{ maxWidth: 1000, mx: "auto", width: "100%" }}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    alignItems: "center",
                    gap: 2,
                    mb: 1,
                    px: 0,
                  }}
                >
                  {/* LEFT - Starting Price */}
                  <Box sx={{ textAlign: "left", minWidth: 0 }}>
                    <Typography
                      sx={{
                        ...labelSx,
                        fontSize: { xs: "0.72rem", sm: "0.8rem" },
                        fontWeight: 600,
                        mb: 0.4,
                      }}
                    >
                      Starting Price
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: FONT,
                        fontSize: { xs: "1rem", sm: "1.2rem" },
                        lineHeight: 1.2,
                        fontWeight: 700,
                        color: R.ink,
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₱ {startPrice.toLocaleString()}
                    </Typography>
                  </Box>

                  {/* RIGHT - Current Bid */}
                  <Box sx={{ textAlign: "right", minWidth: 0 }}>
                    <Typography
                      sx={{
                        ...labelSx,
                        fontSize: { xs: "0.72rem", sm: "0.8rem" },
                        fontWeight: 600,
                        mb: 0.4,
                      }}
                    >
                      Current Bid
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: FONT,
                        fontSize: { xs: "1rem", sm: "1.2rem" },
                        lineHeight: 1.2,
                        fontWeight: 700,
                        color: R.ink,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {hasCurrent
                        ? "₱ " + hammerPrice.toLocaleString()
                        : "No bids yet"}
                    </Typography>
                  </Box>
                </Box>

                {bidError && (
                  <Box
                    role="alert"
                    sx={{
                      mb: 0.75,
                      px: 1.25,
                      py: 0.75,
                      borderLeft: `3px solid ${R.danger}`,
                      bgcolor: R.dangerBg,
                      color: R.danger,
                      fontFamily: FONT,
                      fontSize: "0.8rem",
                      lineHeight: 1.4,
                    }}
                  >
                    {bidError}
                  </Box>
                )}
              </Box>

          </Box>

        </Box>

      )}



      {/* Bell sound trigger used by the "receive_bid_amount" listener (unchanged). */}

      <Button id="sound" style={{ display: "none" }} onClick={SoundTrip}></Button>







      {token === null || guest === 0 ? (

        ""

      ) : (

        <Backdrop

          sx={{

            color: "#fff",

            zIndex: (theme) => theme.zIndex.drawer + 1,

            top: phoneMatch === true ? 60 : 0,

            bgcolor: "rgba(17,17,17,0.82)",

          }}

          open={

            group === "ADMIN"

              ? false      // Tago sa Admin

              : isLive     // Tago kapag OPEN o FAIR_WARNING

              ? false

              : isPending  // Lilitaw kapag PENDING

              ? true

              : isPause    // Lilitaw kapag PAUSE

              ? true

              : false

          }

        >

          <StatusNotice

            tone={isPending ? "light" : "alert"}

            text={

              isPending

                ? "Awaiting Bid Opening"

                : isPause

                ? "PAUSE"

                : message === false

                ? "No Event Yet"

                : ""

            }

          />

        </Backdrop>

      )}



      <Backdrop

        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}

        open={loading}

      >

        <CircularProgress color="inherit" />

      </Backdrop>

    </Box>

  );

}



export default RightLayout;
